"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerPages = exports.PaginationEntity = exports.NewPagination = void 0;
var assertFunctions_1 = require("../../utility/assertFunctions");
var array_1 = require("../../utility/array");
var errors_1 = require("../../utility/errors");
var number_1 = require("../../utility/number");
// 实体类工厂方法，方便转换 UI 组件 入参 props 和构造方法中的入参转换
function NewPagination(props) {
    var total = props.total, current = props.current, pageSize = props.pageSize;
    return new PaginationEntity(total, current, pageSize);
}
exports.NewPagination = NewPagination;
var PaginationEntity = /** @class */ (function () {
    function PaginationEntity(_total, _current, _pageSize) {
        if (_current === void 0) { _current = 1; }
        if (_pageSize === void 0) { _pageSize = 10; }
        this._total = _total;
        this._current = _current;
        this._pageSize = _pageSize;
        this.buttons = 5;
        assertFunctions_1.assertNumber(_total, "total");
        assertFunctions_1.assertNumber(_current, "current");
        assertFunctions_1.assertNumber(_pageSize, "pageSize");
        this.validateParams();
    }
    Object.defineProperty(PaginationEntity.prototype, "current", {
        get: function () {
            return this._current;
        },
        set: function (current) {
            assertFunctions_1.assertNumber(current, "_current");
            this._current = number_1.safeRangeValue(current, [1, this.page]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "total", {
        get: function () {
            return this._total;
        },
        set: function (total) {
            assertFunctions_1.assertNumber(total, "total");
            this._total = total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (pageSize) {
            this.validateParams();
            // 切换分页时动态改变当前页
            var page = Math.ceil(this._total / pageSize);
            if (this.current > page) {
                this._current = page;
            }
            this._pageSize = pageSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "page", {
        get: function () {
            return this._total === 0 ? 1 : Math.ceil(this._total / this._pageSize);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "prev", {
        get: function () {
            return this._current - 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "next", {
        get: function () {
            return this._current + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "hasPrev", {
        get: function () {
            return this._current > 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginationEntity.prototype, "hasNext", {
        get: function () {
            return this._current < this.page;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 动态设置当前页
     * @param page 跳转页码
     */
    PaginationEntity.prototype.goTo = function (page) {
        this.current = page;
        return this.build();
    };
    PaginationEntity.prototype.goPrev = function () {
        if (this.hasPrev) {
            this.goTo(this.prev);
        }
    };
    PaginationEntity.prototype.goNext = function () {
        if (this.hasNext) {
            this.goTo(this.next);
        }
    };
    PaginationEntity.prototype.setButtons = function (buttons) {
        this.validateButtons(buttons);
        this.buttons = buttons;
    };
    /**
       * 构造分页数据
       * @param buttons 分页中按钮的个数，一般为基数个，建议：3,5,7...
       */
    PaginationEntity.prototype.build = function (buttons) {
        var _this = this;
        if (buttons) {
            this.setButtons(buttons);
        }
        var pages = array_1.makeArray(this.page, 1);
        var hasEllipsis = pages.length > this.buttons + 2;
        var items = [];
        if (this.page <= 0) {
            return [
                this.makeCtrl("prev"),
                this.makeItem(1),
                this.makeCtrl("next"),
            ];
        }
        /** buttons: 3, _pageSize: 1
                _total 1: |<|1|>|
                _total 2: |<|1|2|>|
                _total 3: |<|1|2|3|>|
                _total 4: |<|1|.|2|3|4|>|
                _total 5: |<|1|.|2|3|4|.|5|>|
                _total 6: |<|1|.|2|3|4|.|6|>|
                _total 7: |<|1|.|2|3|4|5|6|.|7|>|
            */
        items.push(this.makeCtrl("prev"));
        // 首页
        var firstPage = pages.shift();
        if (firstPage) {
            items.push(this.makeItem(firstPage));
        }
        // 前省略符
        if (hasEllipsis && this._current > Math.ceil(this.buttons / 2) + 1) {
            items.push(this.makeEllipsis("head"));
        }
        // 分页主体
        items.push.apply(items, __spread(getInnerPages(array_1.makeArray(this.page, 1), this.buttons, this._current)
            .map(function (page) { return _this.makeItem(page); })));
        // 后省略符
        if (hasEllipsis && this.page - this._current > Math.ceil(this.buttons / 2)) {
            items.push(this.makeEllipsis("tail"));
        }
        // 尾页
        var lastPage = pages.pop();
        if (lastPage) {
            items.push(this.makeItem(lastPage));
        }
        items.push(this.makeCtrl("next"));
        return items;
    };
    /**
     * 打印图形化输出结果，方便调试
     */
    PaginationEntity.prototype.toPrintString = function () {
        var str = this.build().map(function (item) {
            switch (item.type) {
                case "item":
                    return item.active ? "*" + item.page + "*" : item.page;
                case "ellipsis":
                    return ".";
                case "prev":
                    return "<";
                case "next":
                    return ">";
            }
        }).join("|");
        return "|" + str + "|";
    };
    PaginationEntity.prototype.makeEllipsis = function (dir) {
        return { type: "ellipsis", dir: dir };
    };
    PaginationEntity.prototype.makeCtrl = function (type) {
        return { type: type, disabled: !(type === "prev" ? this.hasPrev : this.hasNext) };
    };
    PaginationEntity.prototype.makeItem = function (page) {
        return { type: "item", active: page === this._current, page: page };
    };
    PaginationEntity.prototype.validatePage = function (page) {
        if (page < 1 || page > this.page) {
            throw new errors_1.OutOfRange("Page should between " + 1 + "~" + this.page);
        }
    };
    PaginationEntity.prototype.validateButtons = function (buttons) {
        if (buttons < 3)
            throw new Error("Button should more than 3");
        if (buttons % 2 === 0)
            throw new Error("Button count should be even");
    };
    PaginationEntity.prototype.validateParams = function () {
        if (this._total < 0) {
            throw new errors_1.ParamNotValid("[Pagination] Negative number not valid.");
        }
        if (this._current > this.page) {
            throw new errors_1.ParamNotValid("[Pagination] Current too large.");
        }
        if (this._current < 1 || this._pageSize < 1) {
            throw new errors_1.ParamNotValid("[Pagination] _current and _pageSize should not less than 1.");
        }
    };
    return PaginationEntity;
}());
exports.PaginationEntity = PaginationEntity;
/**
 * 根据当前页动态生成分页器展示的分页按钮（不包括起始页）
 *       |<--->|
 * |<|*1*|2|3|4|.|10|>|
 *
 * @param pages 一共有多少页数
 * @param buttons 分页按钮数量，一般为奇数个（左右对称）
 * @param current 当前页
 */
function getInnerPages(pages, buttons, current) {
    var firstPage = pages.shift();
    var lastPage = pages.pop();
    if (current === firstPage) {
        return pages.slice(0, buttons);
    }
    if (current === lastPage) {
        return pages.slice(pages.length - buttons);
    }
    var sideCount = Math.floor(buttons / 2);
    var items = [current];
    // head
    for (var i = 0; i < sideCount; i++) {
        var first = items[0];
        if (pages.indexOf(first - 1) > -1) {
            items.unshift(first - 1);
        }
    }
    // tail
    var rest = buttons - items.length;
    for (var i = 0; i < rest; i++) {
        var lastItem = items[items.length - 1];
        if (pages.indexOf(lastItem + 1) > -1) {
            items.push(lastItem + 1);
        }
        else {
            // 回溯前导补齐
            if (items[0] - 1 > 1) {
                items.unshift(items[0] - 1);
            }
        }
    }
    return items;
}
exports.getInnerPages = getInnerPages;
